<template>
  <div id="Loading">
    <transition name="fade">
      <div class="col-xs-2 csp-loading" v-if="loading">
        <i class="fa fa-circle-o-notch fa-spin fa-2"></i>
        <span class="sr-only">Loading...</span>
      </div>
    </transition>
  </div>
</template>

<script>
  export default {
    name: 'Loading',
    props: {
      loading: {
        type: Boolean,
        required: true
      }
    }
  }
</script>

<style scoped>
  
  /* All Mobile Sizes (devices and browser) */
  @media only screen and (max-width: 767px) {



  }
  
  @media only screen and (min-width: 480px) and (max-width: 767px) {

  }
  
  
  @media only screen and (max-width: 479px) {

  }
</style>



// WEBPACK FOOTER //
// Loading.vue?0a458956